import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ImageDialog(props) {
  const {imageList, setOpen, open} = props
    // const [open, setOpen] = React.useState(false);
//   const handleClickOpen = () => {
//     setOpen(true);
//   };

const imgSelection = imageList[0] ?  imageList[0].objName : ''
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
   
      <Dialog
      id={"image-dialog"}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth={'lg'}
        fullWidth={true}

      >
        <DialogContent style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <picture >
    <source  srcSet={`${process.env.REACT_APP_ASSETS_URL}/` +
                                   imgSelection}
            media="(max-width: 825x)"/>
         
    <img style={{maxWidth: 600, maxHeight: 600}}src={imgSelection ? `${process.env.REACT_APP_ASSETS_URL}/` +
                                   imgSelection : "data:,"} alt="" />
</picture>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Exit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
